import { get } from 'lodash';

/**
 * Polling Configuration Service
 * Handles polling configuration state queries for monitored infrastructure
 */

const POLLING_CONFIG_API_URL = '/ngp/v2/polling-config';

/**
 * Fetch polling configuration from the server
 * @param {Object} dataService - The data service instance
 * @returns {Promise<Object>} Polling configuration object
 */
export async function fetchPollingConfig(dataService) {
    try {
        const response = await dataService.get(POLLING_CONFIG_API_URL);
        return Array.isArray(response) ? response[0] : response;
    } catch (error) {
        throw new Error(`Failed to fetch polling configuration: ${error.message}`);
    }
}

/**
 * Check polling configuration status and return warning messages if needed
 * @param {Object} pollingConfig - The polling configuration object
 * @returns {Array<string>} Array of warning messages (empty if no warnings)
 */
export function getPollingConfigWarnings(pollingConfig) {
    const warnings = [];
    const serverEnabled = get(pollingConfig, 'serverEnabled', false);
    const deviceEnabled = get(pollingConfig, 'deviceEnabled', false);

    if (!serverEnabled && !deviceEnabled) {
        warnings.push('Server and device polling have been disabled');
    } else if (!serverEnabled) {
        warnings.push('Server polling has been disabled');
    } else if (!deviceEnabled) {
        warnings.push('Device polling has been disabled');
    }

    return warnings;
}

/**
 * Fetch polling config and return warning messages
 * Convenience method that combines fetch and warning generation
 * @param {Object} dataService - The data service instance
 * @returns {Promise<Array<string>>} Array of warning messages
 */
export async function checkPollingConfigStatus(dataService) {
    const config = await fetchPollingConfig(dataService);
    return getPollingConfigWarnings(config);
}
